/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { userSelectors } from '../../../../../../../../app/resource/user/user.selectors';
import { IUser } from '../../../../../../../../app/resource/user/user.types';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { Tooltip } from '../../../../../../../common/Tooltip';
import { IHeaderUsersProps } from './types';
import { useDispatch } from 'react-redux';
import { filterByMemberIds } from '../../../../../../../../app/page/boards/boards.actions';
import { CircularAvatar } from '../../../../../CustomAvatar';

export const HeaderUsers: FunctionComponent<IHeaderUsersProps> = ({ userIds }) => {
  const users = useSelectWithParams(userSelectors.selectResourcesById, userIds) as IUser[];
  const [usersFiltered, setUsersFiltered] = useState<string[]>([]);
  const dispatch = useDispatch();

  const handleMemberIds = (userId: IUser['id']) => {
    if (usersFiltered.includes(userId)) {
      setUsersFiltered(usersFiltered.filter((id) => id !== userId));
    } else {
      setUsersFiltered((prevState: string[]) => [...prevState, userId]);
    }
  };

  useEffect(() => {
    dispatch(filterByMemberIds(usersFiltered));
  }, [dispatch, usersFiltered]);

  return (
    <div className="flex aic ml-auto">
      {users.map(
        (user: IUser) =>
          user && (
            <a className="small-avatar mr-1" key={`userId-${user.id}`} onClick={() => handleMemberIds(user.id)}>
              <Tooltip
                content={`${user.firstName} ${user.lastName}`}
                direction="top"
                bgColor="#13ac92"
                textColor="white"
                key={user.id}
              >
                <CircularAvatar
                  src={user.image}
                  title={`${user.firstName} ${user.lastName}`}
                  styles={{
                    border: usersFiltered.includes(user.id) ? '3px solid var(--theme-primary-color)' : '',
                    cursor: 'pointer',
                  }}
                />
              </Tooltip>
            </a>
          ),
      )}
    </div>
  );
};
